export default __webpack_public_path__ + "static/media/BookWorld.7da59860efe3f3b49ff54e0a98350c8f.webp";